export default __webpack_public_path__ + "static/media/riso-13.34d49804.jpg";